/**
 * ShopIcons — len NOVÉ ikony pre „Obchod za body" + mapovanie položka → ikona.
 *
 * Staré ikony sa len referencujú menom (z BuzerIcons). NOVÉ (NEW_SHOP_ICONS) pridaj
 * do `ICONS` v BuzerIcons.tsx:
 *     import { NEW_SHOP_ICONS } from "./ShopIcons";
 *     Object.assign(ICONS, NEW_SHOP_ICONS);
 * Potom funguje <BuzerIcon name="lifebuoy" /> aj všetky položky obchodu.
 *
 * Štýl: 24×24, stroke = currentColor, round cap/join — farbu zdedia z rodiča,
 * takže „zlatý" vs „neónový" rámik odlíšiš len farbou (color/CSS), ikona je rovnaká.
 */

export const NEW_SHOP_ICONS: Record<string, { label: string; cat: string; svg: string }> = {
  lifebuoy: {
    label: "Záchranný kruh",
    cat: "ui",
    svg:
      '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.6"/>' +
      '<line x1="12" y1="3" x2="12" y2="8.4"/><line x1="12" y1="15.6" x2="12" y2="21"/>' +
      '<line x1="3" y1="12" x2="8.4" y2="12"/><line x1="15.6" y1="12" x2="21" y2="12"/>',
  },
  frame: {
    label: "Rámik profilu",
    cat: "socialne",
    svg:
      '<circle cx="12" cy="12" r="9"/>' +
      '<circle cx="12" cy="10" r="2.6"/>' +
      '<path d="M7.6 17.2 a4.6 4 0 0 1 8.8 0"/>',
  },
  // v24 — štvorlístok (animácia „štvorlístky"): 4 lupienky + stonka
  clover: {
    label: "Štvorlístok",
    cat: "priroda",
    svg:
      '<circle cx="12" cy="8" r="3"/><circle cx="8" cy="12" r="3"/>' +
      '<circle cx="16" cy="12" r="3"/><circle cx="12" cy="16" r="3"/>' +
      '<line x1="12.6" y1="16.5" x2="14.5" y2="21"/>',
  },
};

/**
 * Položka obchodu (kód) → názov ikony.
 *   ✔ = existujúca v BuzerIcons        ✦ = nová (z NEW_SHOP_ICONS vyššie)
 */
export const SHOP_ICON: Record<string, string> = {
  lifesaver:  "lifebuoy",  // ✦ nová       (Záchranný kruh – ochráni sériu)
  dark_mode:  "moon",      // ✔ existujúca (Tmavý režim)
  gold_frame: "frame",     // ✦ nová       (Zlatý rámik – farba zlatá)
  neon_frame: "frame",     // ✦ nová       (Neónový rámik – farba neón/fialová)
  crown:      "crown",     // ✔ existujúca (Korunka pri mene)
};

/**
 * Render položky:
 *   import { BuzerIcon } from "./BuzerIcons";
 *   import { SHOP_ICON } from "./ShopIcons";
 *   <BuzerIcon name={SHOP_ICON[item.code]} size={28}
 *             style={{ color: item.code === "gold_frame" ? "#d4a017"
 *                            : item.code === "neon_frame" ? "#8b5cf6" : undefined }} />
 *
 * Pozn.: „Záchranný kruh" má v appke ikonu ❄️/🧊 (zmrazenie série). Ak chceš radšej
 * tú metaforu než záchranný kruh, použi existujúcu `snow` namiesto `lifebuoy`.
 *
 * --- Backend (Python) ---
 * SHOP_ICON_PY = {
 *   "lifesaver": "lifebuoy", "dark_mode": "moon",
 *   "gold_frame": "frame", "neon_frame": "frame", "crown": "crown",
 * }
 */
